import IntegrationCallStateOverviewModelBase from '../_generated/modelBases/integration-call-state-overview-model-base';

export default class IntegrationCallStateOverviewModel extends IntegrationCallStateOverviewModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
